import { render, staticRenderFns } from "./listaEmpenho.vue?vue&type=template&id=0310a934"
import script from "./listaEmpenho.vue?vue&type=script&lang=js"
export * from "./listaEmpenho.vue?vue&type=script&lang=js"
import style0 from "./listaEmpenho.vue?vue&type=style&index=0&id=0310a934&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports